import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

function Searchpainting() {
  return (
    <section className="multiple_customization p-100">
      <Container>
        <Row>
          <Col xs={12} md={6} lg={5} xl={5} xxl={5} className="my-auto">
            <h2>Search Through Projects Of Various Specifications</h2>
            <p>
              WAll of the painting jobs in town, accumulated on a single
              dashboard, with all details mentioned, what more can one painter
              ask for? Our Job Listing portal on the Painter’s Dashboard will
              allow you to sift through painting jobs and check their posting
              data, project type, amount being paid among other details.
            </p>
            <p>
              This will help you choose only those projects you are interested
              in.
            </p>
          </Col>
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={6}
            xxl={6}
            className="my-auto offset-xl-1 offset-lg-1 text-center"
          >
            <div className="customizefluid_img">
              <StaticImage
                src="../../../images/case-studies/passion-painting/search_img.webp"
                alt="TekRevol"
                layout="constrained"
                placeholder="blurred"
                formats={["webp"]}
                width={856}
                height={485}
              />
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Searchpainting;
